import React, { useContext, useEffect, useRef, useState } from "react";
import { Fragment } from "react";
import { useNavigate, useParams } from "react-router";
import { Alert, Col, Container, Form, Row } from "reactstrap";

import { Breadcrumbs } from "../../../../AbstractElements";
import PersonalData from "./PersonalData";
import ContactData from "./ContactData";
import BasicData from "./BasicData";
import SocialNetworks from "./SocialNetworks";
import Asesors from "./Asesors";

import { ContactContext } from "../../ContextProvider";
import Entities from "./Entities";
import { alertSuccess } from "../../../../Shared/Utils/alertMessages";
import { useForm } from "react-hook-form";
import { formHasErrors } from "../../../../Shared/Utils/errorUtils";
import { togleLoading } from "../../../../Shared/Utils/alertLoading";

const Index = () => {
  const { id } = useParams();
  const [openAlert, setOpenAlert] = useState(false);
  const refSubmitButtom = useRef();
  //context
  const {
    item,
    getItem,
    setItem,
    activeButton,
    setActiveButton,
    successUpdated,
    setSuccessUpdated,
    createContact,
    updateContact,

    saving,
  } = useContext(ContactContext);
  const onSubmit = (data) => {
    console.log("item", item);
    if (item && item?.id) {
      updateContact(data, item?.id);
    } else {
      createContact(data);
    }
  };
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors, isDirty, isSubmitSuccessful },
  } = useForm({ mode: "all" });

  useEffect(() => {
    id ? getItem(id) : setItem({});
  }, [id]);

  const navigate = useNavigate();

  const handleSave = () => {
    refSubmitButtom?.current?.click();
  };
  const handleBack = () => {
    navigate(`${process.env.PUBLIC_URL}/app/contacts`);
  };

  useEffect(() => {
    //lo que efecuta cuando se destruye el component
    return () => {
      reset({}, { keepValues: true, keepErrors: false, keepDirty: false });
      setItem({});
      setSuccessUpdated(false);
      setActiveButton(false);
    };
  }, []);

  useEffect(() => {
    if (successUpdated !== false) {
      alertSuccess("Registro actualizado !");
      setSuccessUpdated(false);
      setActiveButton(false);
    }
  }, [successUpdated]);

  useEffect(() => {
    setOpenAlert(activeButton !== false ? true : false);
  }, [activeButton]);

  // Watch all errors
  const watchedErrors = watch(() => errors);
  useEffect(() => {
    if (formHasErrors(errors)) {
      setActiveButton(false);
    } else {
      if (isDirty) {
        setActiveButton(true);
      }
    }
  }, [watchedErrors]);

  useEffect(() => {
    reset({}, { keepValues: true, keepErrors: false, keepDirty: false });
  }, [isSubmitSuccessful]);

  useEffect(() => {
    togleLoading(saving);
  }, [saving]);

  return (
    <Fragment>
      <Breadcrumbs
        parent="Contactos"
        title={item?.id ? "Modificar contacto" : "Nuevo contacto"}
        mainTitle={item?.id ? "Modificar contacto" : "Nuevo contacto"}
      />

      <Container fluid={true} className="add-product">
        <Form onSubmit={handleSubmit(onSubmit)} id="basicDataForm">
          <Row>
            <Col md="4"></Col>
            <Col md="4">
              {
                <div className="form-footer  text-end mb-4">
                  <Alert
                    className="alert"
                    color="warning inverse"
                    isOpen={openAlert}
                  >
                    <i class="icon-info"></i>
                    Guarda los cambios antes de salir !
                  </Alert>
                </div>
              }
            </Col>
            <Col md="4">
              <div className="form-footer  text-end mb-4">
                <button
                  className={`btn btn-block btn-ligth`}
                  type="button"
                  onClick={handleBack}
                >
                  <i className="icon-angle-left"></i> Volver
                </button>
                <button
                  className={`btn btn-block btn-${
                    activeButton !== false ? "success" : "secondary"
                  }`}
                  type="button"
                  disabled={activeButton === false}
                  onClick={handleSave}
                >
                  Guardar
                </button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="4" md="12" className="edit-profile">
              <BasicData
                contactId={id}
                register={register}
                errors={errors}
                reset={reset}
                setValue={setValue}
              />
            </Col>
            {item.position != "PERIODISTA" && (
              <Col lg="8" md="12">
                {
                  <PersonalData
                    contactId={id}
                    register={register}
                    errors={errors}
                    reset={reset}
                    setValue={setValue}
                  />
                }
              </Col>
            )}

            <Col lg="5">
              {
                <ContactData
                  contactId={id}
                  register={register}
                  errors={errors}
                  reset={reset}
                  setValue={setValue}
                />
              }

              {item?.charge?.name === "PERIODISTA" && (
                <Entities
                  register={register}
                  errors={errors}
                  reset={reset}
                  setValue={setValue}
                />
              )}
            </Col>
            <Col lg="7">
              {
                <SocialNetworks
                  contactId={id}
                  register={register}
                  errors={errors}
                  reset={reset}
                  setValue={setValue}
                />
              }
            </Col>
          </Row>
          <button hidden={true} ref={refSubmitButtom} type={"submit"} />
        </Form>
        {item?.charge?.name != "ASESOR" && (
          <Row>
            <Col lg="12">
              {
                <Asesors
                  register={register}
                  errors={errors}
                  reset={reset}
                  setValue={setValue}
                />
              }
            </Col>
          </Row>
        )}
      </Container>
    </Fragment>
  );
};

export default Index;
